// Import the functions you need from the SDKs you need
import {
    initializeApp
} from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import {
    getFirestore,
    connectFirestoreEmulator} from "firebase/firestore";

const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.0/8 are considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
window.location.hostname.includes('ngrok') ||
window.location.hostname.includes('liff'));

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDqMxGOQPTL89iFDf4VubRLa0ZY-hWOvS4",
  authDomain: "watahhh-official.firebaseapp.com",
  databaseURL: "https://watahhh-official.firebaseio.com",
  projectId: "watahhh-official",
  storageBucket: "watahhh-official.appspot.com",
  messagingSenderId: "410192057577",
  appId: "1:410192057577:web:e9f669f7944ab424838c78"
  };
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

if (isLocalhost) {
    console.log('====================================');
    console.log('🔥 Firebase running on localhost');
    console.log('====================================');
    connectFirestoreEmulator(db, "localhost", 8080); //
}
export default db;